import styled from 'styled-components'
import Button from '@/components/blocks/Button'

export const MessageContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 10px;
  border-radius: 4px;
  background: #F9EAD5;
  color: #E5910C;
  font-size: 1.2rem;
  line-height: 1.6rem;
  font-weight: 500;
  text-align: left;
  svg {
    width: 22px;
    margin: -1px 5px 0 0;
  }
`

export const SubmitButton = styled(Button)`
  width: 100%;
  padding: 7px;
  margin-top: 15px;
  color: ${({ theme }) => theme.colors.colors.light};
  background: ${({ theme }) => theme.colors.scheme.backgrounds.fuelYellow};
  text-transform: inherit;
  :hover {
    background: ${({ theme }) => theme.colors.scheme.backgrounds.fuelYellow};
  }
`

export const CancelButton = styled(Button)`
  width: 100%;
  padding: 7px;
  margin-top: 15px;
  color: ${({ theme }) => theme.colors.colors.light};
  background: ${({ theme }) => theme.colors.backgrounds.redisign.error};
  text-transform: inherit;
  :hover {
    background: ${({ theme }) => theme.colors.backgrounds.redisign.error};
  }
`